import queryString from "query-string";

import Header from "#src/components/Header/Header.jsx";
import LostFoundCenter from "../../features/LostFound/components/LostFoundCenter";
import PrivacyAgree from "./../../features/LostFound/components/modal/PrivacyAgree";
import CheckListedLostItem from "./../../features/LostFound/components/modal/CheckListedLostItem";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useCheckListedItem from "#src/features/LostFound/hooks/useCheckListedItem.js";

const LostFoundCenterPage = () => {
  const { checkListedItem, list } = useCheckListedItem();
  const handleOnClick = () => {
    checkListedItem();
  };

  const location = useLocation();

  const [isLostedItemModalOpen, setIsLostedItemModalOpen] = useState(false);
  const [isAgreeOpen, setIsAgreeOpen] = useState(false);

  const openModal = (setModalState) => {
    setModalState(true);
  };

  const closeModal = (setModalState) => {
    setModalState(false);
  };

  useEffect(() => {
    const queryParams = queryString.parse(location.search);
    if (queryParams.agree) {
      openModal(setIsAgreeOpen);
    } else if (queryParams.exist) {
      openModal(setIsLostedItemModalOpen);
    } else {
      closeModal(setIsAgreeOpen);
      closeModal(setIsLostedItemModalOpen);
    }
  }, [location.search]);
  return (
    <>
      <section className="h-screen p-hasHeader">
        <Header title="e-유실물센터" />
        <LostFoundCenter handleOnClick={handleOnClick} />
      </section>
      <PrivacyAgree
        isOpen={isAgreeOpen}
        onRequestClose={() => {
          closeModal(setIsAgreeOpen);
        }}
      />
      <CheckListedLostItem
        list={list}
        isOpen={isLostedItemModalOpen}
        onRequestClose={() => {
          closeModal(setIsLostedItemModalOpen);
        }}
      />
    </>
  );
};

export default LostFoundCenterPage;
